import {bulkExportLinksOrderPosterCanvas} from "../../../../../services/api/3dApi"

export default function (props) {
    const {query} = props
    const {type = ''} = query

    let rqUrl = ''

    if (type) {
        rqUrl += `?type=${type}`
    }

    window.open(bulkExportLinksOrderPosterCanvas(rqUrl))
}
